<template>
    <CardPage :section="11" :page="3" :audio="true">
        <p>Great job! Here's a summary of the {{ stepsOrder.length }} steps to effective condom use:</p>
        <ol>
            <li v-for="(key, index) in stepsOrder" :key="index">{{ steps[key].text }}</li>
        </ol>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        steps: get('section11/steps'),
        stepsOrder: get('section11/stepsOrder')
    }
};
</script>
